<app-page-base>

  <p-card [header]="getTitle()"
          class="flex h-full min-h-0 flex-1 flex-col"
          [pt]="{ 
            root: 'h-full min-h-0 flex flex-col flex-1',
            body: 'h-full min-h-0 flex flex-col flex-1 overflow-hidden p-5',
            content: 'h-full min-h-0 flex flex-col flex-1'
          }">
    <div class="flex h-full min-h-0 flex-col gap-4">

      <!-- Sezione controlli (Fissa in alto) -->
      <div class="justify-end-safe flex flex-none flex-row gap-3">
        <p-datepicker inputId="Inizio" [(ngModel)]="startDate" [showTime]="true" [hourFormat]="'24'" />
        <p-button icon="pi pi-refresh" (click)="onReload()" />
        <p-button class="ml-5" icon="pi pi-user-edit" (click)="onShowDialog()" />
      </div>

      <!-- Contenitore del contenuto che DEVE scrollare -->
      <!-- 'flex-1' prende lo spazio restante, 'overflow-y-auto' attiva lo scroll -->
      <div class="min-h-0 flex-1 overflow-y-auto">
        <div class="flex flex-row flex-wrap">
          @if (isShown(1)) {
          <app-signal class="flex-item" [titolo]="getName(1)" [udm]="'bpm'"
                      (onZoomChanged)="onZoomChanged($event)" (onZoomCommand)="onZoomCommand($event)"
                      [zoomLevel]="zoomLevel.asObservable()" [zoomCommand]="zoomCommand.asObservable()"
                      [xMax]="xMax" [xMin]="xMin"
                      [segnale]="segnaleFreqCardiaca" [loading]="loadingFreqCardiaca" />
          }
          @if (isShown(2)) {
          <app-signal class="flex-item" [titolo]="getName(2)" [udm]="'rpm'"
                      (onZoomChanged)="onZoomChanged($event)" (onZoomCommand)="onZoomCommand($event)"
                      [zoomLevel]="zoomLevel.asObservable()" [zoomCommand]="zoomCommand.asObservable()"
                      [xMax]="xMax" [xMin]="xMin"
                      [segnale]="segnaleFreqRespiratoria" [loading]="loadingFreqRespiratoria" />
          }
          @if (isShown(3)) {
          <app-signal class="flex-item" [titolo]="getName(3)" [udm]="'bpm'"
                      (onZoomChanged)="onZoomChanged($event)" (onZoomCommand)="onZoomCommand($event)"
                      [zoomLevel]="zoomLevel.asObservable()" [zoomCommand]="zoomCommand.asObservable()"
                      [xMax]="xMax" [xMin]="xMin"
                      [segnale]="segnaleRR" [loading]="loadingRR" />
          }
          @if (isShown(4)) {
          <app-signal class="flex-item" [titolo]="getName(4)" [udm]="'%'"
                      (onZoomChanged)="onZoomChanged($event)" (onZoomCommand)="onZoomCommand($event)"
                      [zoomLevel]="zoomLevel.asObservable()" [zoomCommand]="zoomCommand.asObservable()"
                      [xMax]="xMax" [xMin]="xMin"
                      [segnale]="segnaleSat" [loading]="loadingSat" />
          }
          @if (isShown(5)) {
          <app-signal class="flex-item" [titolo]="getName(5)" [udm]="'°C'"
                      (onZoomChanged)="onZoomChanged($event)" (onZoomCommand)="onZoomCommand($event)"
                      [zoomLevel]="zoomLevel.asObservable()" [zoomCommand]="zoomCommand.asObservable()"
                      [xMax]="xMax" [xMin]="xMin"
                      [segnale]="segnaleTemp" [loading]="loadingTemp" />
          }
        </div>
      </div>
    </div>
  </p-card>

  <p-dialog header="Seleziona le Misure"
            [(visible)]="showDialog"
            [modal]="true"
            [closable]="false"
            [draggable]="false"
            [resizable]="false">

    <p-listbox [(ngModel)]="selectedMeasures" [options]="availableMeasures" [multiple]="true" [checkbox]="true" optionLabel="name" />

    <ng-template #footer>
      <p-button label="Annulla"
                severity="secondary"
                variant="outlined"
                (click)="onClose()" />
      <p-button label="Salva"
                (click)="onSave()" />
    </ng-template>
  </p-dialog>

</app-page-base>
